import PubSub from "./PubSub";
import API from '@API/index';

class PubSubGeofence extends PubSub {
  protected company: Company;
  protected siteId: string | null = null;

  constructor(company: Company, siteId: string | null, onMessage: Function, onError?: Function, onComplete?: Function) {
    super(onMessage, onError, onComplete);
    this.company = company;
    this.siteId = siteId
  }

  public connect(): void {
    const { companyId } = this.company;

    let topicName: string = '';

    if (this.siteId === null) topicName = `dashboard/events/${companyId}/+/+/geofence-triggered`;
    else topicName = `dashboard/events/${companyId}/${this.siteId}/+/geofence-triggered`;

    this.subscription = API.PubSub.subscribeToTopic(topicName, this.onMessage, this.onError, this.onComplete);

    this.interval = setInterval(() => { this.checkSubscriptionHealth() }, 15000);
  }
}

export default PubSubGeofence;
